// app/lib/api.ts — getypte fetch-wrapper over /api/v1.
import type { Envelope } from '#shared/types/admin';

export class ApiError extends Error {
  code: string;
  status: number;
  details?: Record<string, unknown>;
  constructor(code: string, message: string, status: number, details?: Record<string, unknown>) {
    super(message);
    this.code = code;
    this.status = status;
    this.details = details;
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(`/api/v1${path}`, {
    method,
    credentials: 'same-origin',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });

  let payload: Envelope<T> | null = null;
  try { payload = (await res.json()) as Envelope<T>; } catch { /* geen JSON */ }

  if (!res.ok || !payload || payload.error) {
    const e = payload?.error;
    // Vangnet: mocht er ooit een niet-enveloped foutvorm doorheen komen, dan
    // nog steeds een leesbaar bericht in plaats van "HTTP 409".
    const message = typeof e === 'string' ? e : e?.message
      ?? (payload as { error?: string } | null)?.error
      ?? `HTTP ${res.status}`;
    throw new ApiError(e?.code ?? 'server_error', String(message), res.status, e?.details);
  }
  return payload.data as T;
}

export const api = {
  get: <T,>(p: string) => request<T>('GET', p),
  post: <T,>(p: string, body?: unknown) => request<T>('POST', p, body),
  patch: <T,>(p: string, body?: unknown) => request<T>('PATCH', p, body),
  put: <T,>(p: string, body?: unknown) => request<T>('PUT', p, body),
  del: <T,>(p: string) => request<T>('DELETE', p),
};
